import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { CoverageContainer, Coverage, Constants } from './../../shared';
import { CoverageViewConfig, CoverageFormService } from '@bhtp-client-web/component';

import * as moment from 'moment';

@Component({
    selector: 'optional-coverage-list',
    template: require('./optional-coverage-list.component.html')
})
export class OptionalCoverageListComponent {
    @Input() public formConfiguration: CoverageViewConfig;
    @Input() public optionalCoveragesFormArray: FormArray;
    @Input() public requoteCFAR: boolean;
    @Input() public quoting: boolean;
    @Input() public submitted: boolean;

    @Output() public valueChanges: EventEmitter<CoverageContainer> = new EventEmitter<CoverageContainer>();

    private formInitialized: boolean;

    constructor(private formService: CoverageFormService) { }

    public ngOnChanges(): void {
        if (this.formConfiguration && this.optionalCoveragesFormArray && !this.formInitialized) {
            this.formService.buildCoverageFormArray(this.optionalCoveragesFormArray, this.formConfiguration);
            this.optionalCoveragesFormArray.valueChanges.debounceTime(500).subscribe((changes) => {
                let coverageContainer: CoverageContainer = new CoverageContainer();
                coverageContainer.optionalCoverages = new Array<Coverage>();
                for (let i: number = 0; i <= this.optionalCoveragesFormArray.length - 1; i++) {
                    let convertedCoverage: Coverage = Coverage.combineOptionalCoverageFormGroupAndEditCoverageToEditCoverage(this.formConfiguration.optionalCoverages[i], <FormGroup>this.optionalCoveragesFormArray.controls[i]);

                    // if coverage requires dates and the dates are provided, then calculate premium from date range
                    // if no dates, then don't add the coverage
                    if (Coverage.hasDates(this.formConfiguration.optionalCoverages[i])) {
                        coverageContainer.rentalInformation = (Coverage.combineOptionalCoverageFormGroupAndCoverageToRentalInformation(this.formConfiguration.optionalCoverages[i], <FormGroup>this.optionalCoveragesFormArray.controls[i]));
                        if (coverageContainer.rentalInformation.rentalCarPickupDate && coverageContainer.rentalInformation.rentalCarReturnDate) {
                            let returnDate: moment.Moment = moment(coverageContainer.rentalInformation.rentalCarReturnDate, Constants.DATE_PARSE_FORMAT);
                            let pickupDate: moment.Moment = moment(coverageContainer.rentalInformation.rentalCarPickupDate, Constants.DATE_PARSE_FORMAT);
                            if (pickupDate.isValid() && returnDate.isValid()) {
                                // if dates are valid, find the difference and see if a premium per day was calculated for
                                // the specified length
                                let diff: number = returnDate.diff(pickupDate, 'days', false) + 1;
                                if (this.formConfiguration.optionalCoverages[i].premiumsByDay &&
                                    this.formConfiguration.optionalCoverages[i].premiumsByDay[diff]) {
                                    this.formConfiguration.optionalCoverages[i].premium = this.formConfiguration.optionalCoverages[i].premiumsByDay[diff];
                                    convertedCoverage.daySpan = diff;
                                    coverageContainer.optionalCoverages.push(convertedCoverage);
                                }
                            }
                        }
                    }
                    else {
                        coverageContainer.optionalCoverages.push(convertedCoverage);

                        // if cfar is selected and values changed,
                        if (this.formConfiguration.optionalCoverages[i].ratingId === Constants.COVERAGE_CFAR && this.requoteCFAR &&
                            convertedCoverage.isSelected) {
                            coverageContainer.requiresRequote = true;
                        }
                    }
                }
                this.valueChanges.emit(coverageContainer);
            });

            this.formInitialized = true;
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/purchase/coverages/optional-coverage-list.component.ts